import { MembershipFees, UpsertMemberDTO, RenewAussieTimesDTO } from '@/types/portal/Member';

import { api } from "../api";
import { getErrorResponse } from "../errorHandler";

export const getMemberFees = async (): Promise<MembershipFees | null> => {
  try {
    const { data } = await api.get<any>('/Person/member/fees');
    return data;
  } catch (err) {
    return null;
  }
}

export const getAuxiliaryMembers = async (): Promise<any> => {
  try {
    const { data } = await api.get<any>('/Person/member/aux-members');
    return data;
  } catch (err) {
    return null;
  }
}

export const linkToMembership = async (memberId: string): Promise<any> => {
  try {
      const { data } = await api.post<any>(`/Person/member/link`, { memberId });
      return {...data, success: true};
  } catch (err) {

    const response = getErrorResponse(err);
    if (response?.status === 400) {
      return { errors: response.data?.errors };
    }

    throw err;
  }
}

export const registerMembership = async (dto: UpsertMemberDTO): Promise<any> => {
  try {
    const { data } = await api.post<any>(`/Person/member/register`, dto);
    return {...data, success: true};
  }  catch (err) {
      const response = getErrorResponse(err);
      if (response?.data) {
        return {...response.data, success: false};
      } else {
        return { errors: ["An Unknown Error Occured"], success: false };
      }
  }
}

export const renewMembership = async (dto: UpsertMemberDTO): Promise<any> => {
  try {
    const { data } = await api.post<any>(`/Person/member/renew`, dto);
    return {...data, success: true};
  }  catch (err) {
      const response = getErrorResponse(err);
      if (response?.data) {
        return {...response.data, success: false};
      } else {
        return { errors: ["An Unknown Error Occured"], success: false };
      }
  }
}

export const renewAussieTimes = async (dto: RenewAussieTimesDTO): Promise<any> => {
  try {
    const { data } = await api.post<any>('/Person/member/renew-aussie-times', dto);
    return {...data, success: true};
  }  catch (err) {
      const response = getErrorResponse(err);
      if (response?.data) {
        return {...response.data, success: false};
      } else {
        return { errors: ["An Unknown Error Occured"], success: false };
      }
  }
}

export const orderPedigree = async (dto: any): Promise<any> => {
  try {
    const { data } = await api.post<any>('/Person/member/pedigreeOrder', dto);
    return {...data, success: true};
  }  catch (err) {
      const response = getErrorResponse(err);
      if (response?.data) {
        return {...response.data, success: false};
      } else {
        return { errors: ["An Unknown Error Occured"], success: false };
      }
  }
}


export default {
  getMemberFees,
  getAuxiliaryMembers,
  linkToMembership,
  registerMembership,
  renewMembership,
  renewAussieTimes,
  orderPedigree,
};
